import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  signal
} from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Payment } from "@components/payment-card/payment-card.component";
import meiosPagamento from "@static/metodosPagamento.json";
import yon from "@static/yesOrNot.json";
import { Subscription } from "rxjs";
import { v4 } from "uuid";

@Component({
  selector: "app-payments",
  templateUrl: "./payments.component.html",
  styleUrls: ["./payments.component.scss"]
})
export class PaymentsComponent {
  @Input() defaultValue = 0;
  @Output() changePayments = new EventEmitter<Payment[]>();

  active = signal(false);

  active$ = toObservable(this.active).subscribe((active) => {
    document.body.style.overflow = active ? "hidden" : "auto";
  });

  toEdit = signal<Payment | null>(null);

  payments = signal<Payment[]>([]);

  payments$ = toObservable(this.payments).subscribe((payments) => {
    this.changePayments.emit(payments);
  });

  toEdit$ = toObservable(this.toEdit).subscribe((value) => {
    if (!value) {
      this.setDefaultPaymentForm();
    }
  });

  yon = yon;
  meios = meiosPagamento;

  paymentForm = new FormGroup({
    aVista: new FormControl<boolean>(true, {
      nonNullable: true
    }),
    meio: new FormControl<string>("01", {
      nonNullable: true
    }),
    descricaoMeio: new FormControl<string>("Dinheiro", {
      nonNullable: true
    }),
    valor: new FormControl<string | number>(0, {
      nonNullable: true,
      validators: [Validators.required]
    })
  });

  $: Subscription[] = [];

  constructor(private destroyRef: DestroyRef) {
    this.setDefaultPaymentForm();

    this.$.push(
      this.paymentForm.controls.meio.valueChanges.subscribe((meio) => {
        this.paymentForm.controls.descricaoMeio.setValue(
          this.meios.find((m) => m.value === meio)?.display ?? ""
        );
      })
    );

    this.destroyRef.onDestroy(() => {
      this.$.forEach(($) => $.unsubscribe());
      this.toEdit$.unsubscribe();
      this.payments$.unsubscribe();
    });
  }

  edit(id: string) {
    const payment = this.payments().find((p) => p.id === id);

    if (!payment) return;

    this.paymentForm.setValue({
      aVista: payment.aVista,
      descricaoMeio: payment.descricaoMeio,
      meio: payment.meio,
      valor: payment.valor
    });

    this.toEdit.set(payment);
    this.active.set(true);
  }

  save() {
    if (!this.paymentForm.valid) return;

    if (this.toEdit()) {
      this.payments.update((old) =>
        old.map((payment) => ({
          ...payment,
          ...(this.toEdit()?.id === payment.id && {
            ...this.paymentForm.value
          })
        }))
      );
    } else {
      this.payments.update((old) => [
        ...old,
        {
          aVista: true,
          descricaoMeio: "",
          meio: "",
          valor: 0,
          id: v4(),
          ...this.paymentForm.value
        }
      ]);
    }

    this.active.set(false);
  }

  openAddModal() {
    this.toEdit.set(null);
    this.setDefaultPaymentForm();
    this.active.set(true);
  }

  private setDefaultPaymentForm() {
    this.paymentForm.setValue(
      {
        aVista: true,
        meio: "01",
        descricaoMeio: "Dinheiro",
        valor: this.defaultValue || 0
      },
      {
        emitEvent: false
      }
    );
  }
}
